import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import {
  CCol,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
} from "@coreui/react";
import "reactjs-popup/dist/index.css";
import { loadingState } from "src/atom/LoadingState";
import { useRecoilState } from "recoil";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  getTicketLabelListing,
  getTicketTemplate,
  replyTicketFromTemplate,
  unasignTicketLabel,
} from "src/services/Tickets/StudentTicketService";
import { useNavigate } from "react-router-dom";
import Confirmation from "src/components/Confirmation";
import { alertMessageState } from "src/atom/LoadingState";
import Paginator from "src/components/Paginator";

const LabelListing = () => {
  const courseObj = {
    ticketIds: [],
    content: "",
  };

  const [validationErrors, setValidationErrors] = useState({
    content: "",
  });
  const [selectedFile, setSelectedFile] = useState([]);
  const location = useLocation();
  const { id } = location.state || {};
  const [visible, setVisible] = useState(false);
  const [, setLoading] = useState(false);
  const [, enableLoader] = useRecoilState(loadingState);
  const [formData, setFormData] = useState(courseObj);
  const [template, setTemplate] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [ticketListing, setTicketListing] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [, setIsSubmitted] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [ticketId, setTicketId] = useState(null);
  const [, setAlertMessage] = useRecoilState(alertMessageState);
  const [nextViewHistory, setNextViewHistory] = useState(null);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    totalItems: 0,
    totalPages: 0,
    next: "",
    prev: "",
    size: 10,
    search: "",
  });

  const nextPage = (event) => {
    setPagination((prevValue) => ({
      ...prevValue,
      currentPage: event,
    }));
  };

  useEffect(() => {
    fetchLabelListing();
    fetchingTemplate();
  }, [pagination.currentPage, pagination.size]);

  const toggleSelectRow = (ticketIds) => {
    if (selectAll) {
      setSelectedRows((prevRows) =>
        prevRows.includes(ticketIds)
          ? prevRows.filter((row) => row !== ticketIds)
          : [...prevRows, ticketIds]
      );
      setSelectAll(false);
    } else {
      if (selectedRows.includes(ticketIds)) {
        setSelectedRows(selectedRows.filter((row) => row !== ticketIds));
        setFormData({});
      } else {
        setSelectedRows([...selectedRows, ticketIds]);
        setFormData((prevFormData) => ({
          ...prevFormData,
          ticketIds: [...(prevFormData.ticketIds || []), ticketIds],
        }));
      }
    }
  };

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      const allTicketIds = ticketListing.map((tickets) => tickets.id);
      setSelectedRows(allTicketIds);
      setFormData((prevFormData) => ({
        ...prevFormData,
        ticketIds: allTicketIds,
      }));
    } else {
      setSelectedRows([]);
      setFormData({});
    }
  };

  const validateForm = () => {
    let errors = {};
    let isValid = true;
    if (!formData.content) {
      errors.content = "Please provide Description ";
      isValid = false;
    }
    setValidationErrors(errors);
    return isValid;
  };

  const fetchingTemplate = async () => {
    const response = await getTicketTemplate({});
    setTemplate(response.body);
  };

  const fetchLabelListing = async () => {
    enableLoader(true);
    var getLabelListing = async () => {
      enableLoader(false);
      var response = await getTicketLabelListing(
        {
          pageNumber: pagination.currentPage,
          search: pagination.search,
          pageSize: pagination.size,
        },
        id
      );
      if (response.success) {
        setTicketListing(response.body.tickets);
        setNextViewHistory(response.body.tickets.map((ticket) => ticket.id));
        setPagination((prevValue) => ({
          ...prevValue,
          totalItems: response.body.totalElements,
          totalPages: Math.ceil(response.body.totalElements / pagination.size),
        }));
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(`${response.message}`);
      }
    };
    getLabelListing();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const navigate = useNavigate();
  const handleView = (id) => {
    navigate("/viewTicketHistory", { state: { id, nextViewHistory } });
  };

  const handleDelete = (id, label, ticketNumber) => {
    setTicketId(id);
    setWarningMessage(
      `Are you sure you want to remove '${ticketNumber}' from ${label}`
    );
  };

  const handleRemove = async (id) => {
    enableLoader(true);
    var removeTicketLabels = async () => {
      var response = await unasignTicketLabel(ticketId);
      if (response.success) {
        fetchLabelListing();
        enableLoader(false);
        setTicketId(null);
      } else {
        enableLoader(false);
        setAlertMessage(`${response.message}`);
      }
    };
    removeTicketLabels();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const isValid = validateForm();
    if (isValid) {
      setValidationErrors({});
      setLoading(true);
      const formValues = new FormData();
      formValues.append("files", selectedFile);
      formValues.append("ticketReply", JSON.stringify(formData));
      const response = await replyTicketFromTemplate(formValues);
      if (response.success) {
        setFormData("");
        fetchLabelListing();
        fetchingTemplate();
        setVisible(false);
        alert("Reply successfully send to selected candidates");
      } else {
        setAlertMessage(`${response.message}`);
      }
      setLoading(false);
      setSelectedRows([]);
    }
  };

  const handleTemplateChange = (templateIds) => {
    const selectedTemplate = template?.templates.find(
      (temp) => temp.id === templateIds
    );
    setFormData((prevData) => ({
      ...prevData,
      content: selectedTemplate?.content || "",
    }));
  };

  const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
    useDropzone({
      onDrop: (files) => setSelectedFile(files),
      maxFiles: 3,
    });

  const handleButtonClick = () => {
    navigate("/manage-labels");
  };

  return (
    <>
      <div className="card mt-3">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <span className="mr-auto">Add labels</span>
            <div className="d-flex flex-column flex-md-row">
              <CButton
                onClick={() => {
                  setVisible(!visible);
                }}
                className="mb-2 mb-md-0"
              >
                Reply All
              </CButton>
              <CButton
                className="ms-md-3"
                onClick={() => {
                  handleButtonClick();
                }}
              >
                Back
              </CButton>
            </div>
          </div>
        </div>
        <div className="card-body">
          <CCol xs={12}>
            <CTable striped responsive>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={toggleSelectAll}
                      />
                      <label htmlFor="selectAll" style={{ marginLeft: "5px" }}>
                        Select All
                      </label>
                    </div>
                  </CTableHeaderCell>
                  <CTableHeaderCell scope="col">S.No</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Ticket Number</CTableHeaderCell>
                  <CTableHeaderCell scope="col">
                    Ticket Category
                  </CTableHeaderCell>
                  <CTableHeaderCell scope="col">
                    Ticket Sub-Category
                  </CTableHeaderCell>
                  <CTableHeaderCell scope="col">
                    CET Registration Id
                  </CTableHeaderCell>
                  <CTableHeaderCell scope="col">Student Name</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Date</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Label</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {ticketListing?.map((tickets, index) => (
                  <OverlayTrigger
                    key={`tooltip-${index}`}
                    placement="top"
                    overlay={
                      <Tooltip
                        id={`tooltip-${index}`}
                      >{`${tickets.query} || -NA-`}</Tooltip>
                    }
                  >
                    <CTableRow key={index}>
                      <CTableHeaderCell scope="row">
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(tickets.id)}
                          onChange={() => toggleSelectRow(tickets.id)}
                        />
                      </CTableHeaderCell>
                      <CTableHeaderCell>{index + 1}</CTableHeaderCell>
                      <CTableDataCell>{tickets?.ticketNumber}</CTableDataCell>
                      <CTableDataCell>{tickets?.ticketCategory}</CTableDataCell>
                      <CTableDataCell>{tickets?.subCategory}</CTableDataCell>
                      <CTableDataCell>
                        {tickets?.raisedBy?.userId}
                      </CTableDataCell>
                      <CTableDataCell>{tickets?.raisedBy?.name}</CTableDataCell>
                      <CTableDataCell>
                        {tickets?.lastStatusUpdate}
                      </CTableDataCell>
                      <CTableDataCell>{tickets?.label}</CTableDataCell>
                      <CTableDataCell>
                        <div className="d-flex">
                          <button
                            className="btn btn-primary btn-sm me-2"
                            onClick={() => handleView(tickets.id)}
                          >
                            View
                          </button>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() =>
                              handleDelete(
                                tickets.id,
                                tickets.label,
                                tickets.ticketNumber
                              )
                            }
                          >
                            Remove
                          </button>
                        </div>
                      </CTableDataCell>
                    </CTableRow>
                  </OverlayTrigger>
                ))}
              </CTableBody>
            </CTable>
          </CCol>
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <Paginator
                pagination={pagination}
                range={3}
                nextPage={nextPage}
                setPagination={setPagination}
              />
            </div>
          </div>
          <CModal
            scrollable
            visible={visible}
            onClose={() => setVisible(false)}
            size="xl"
          >
            <CModalHeader>
              <CModalTitle> Labels </CModalTitle>
            </CModalHeader>
            <CModalBody>
              <div style={{ overflow: "hidden" }}>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row mb-2">
                      <div className="col-md-3 mb-2 ms-5">
                        <label htmlFor="totalSeats">Select Template</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <select
                            name="ticketCategoryId"
                            className={`form-control`}
                            onChange={(e) => {
                              handleTemplateChange(e.target.value);
                            }}
                            id="ticketCategoryId"
                          >
                            <option>Select Template</option>
                            {template?.templates?.map((result) => (
                              <option key={result.id} value={result.id}>
                                {result.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-3 mb-2 ms-5">
                        <label htmlFor="totalSeats">Ticket Description</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <textarea
                            rows="6"
                            className={`form-control ${
                              validationErrors.content ? "is-invalid" : ""
                            }`}
                            id="content"
                            placeholder="Please describe your ticket"
                            name="content"
                            value={formData?.content}
                            onChange={handleInputChange}
                          />
                          {validationErrors.content && (
                            <div className="invalid-feedback">
                              {validationErrors.content}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-3 mb-2 ms-5">
                        <label>Attachment</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div {...getRootProps()} className="dropzone">
                            <input {...getInputProps()} />
                            <div className="dropzone-content">
                              {isDragActive ? (
                                <p>Drop the file here ...</p>
                              ) : (
                                <p>
                                  {isDragActive
                                    ? "Drop the file here ..."
                                    : "Drag 'n' drop a file here, or click to select a file"}
                                </p>
                              )}
                            </div>
                          </div>
                          {acceptedFiles.length > 0 && (
                            <div>
                              <strong>Selected File:</strong>
                              <ul>
                                {acceptedFiles.map((file) => (
                                  <li key={file.path}>{file.path}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                          {validationErrors.file && (
                            <div className="invalid-feedback">
                              {validationErrors.file}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3 mb-5 mt-5 justify-content-center">
                      <div className="col-md-6 text-center">
                        <button
                          type="submit"
                          className="btn btn-sm btn-success text-white me-2"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </CModalBody>
          </CModal>
          <Confirmation
            onCancel={() => {
              setWarningMessage("");
            }}
            onContinue={() => {
              handleRemove();
              setWarningMessage("");
            }}
            warning={warningMessage}
          />
        </div>
      </div>

      <style>
        {`
          .dropzone {
            border: 2px dashed #cccccc;
            border-radius: 4px;
            padding: 60px;
            text-align: center;
            margin-top: 10px; /* Add margin for spacing */
          }

          .dropzone-content {
            color: #555555;
          }
          .sub-dropdown {
            display: none;
          }
          .assign-label-dropdown:hover .dropdown-menu {
            display: block;
          }
        `}
      </style>
    </>
  );
};
export default LabelListing;
